import { Component, input } from '@angular/core';
import { MobileNumberDto } from '@workspace/data-types';
import { ObfuscateMobileNumberPipe } from '../../../../../pipes/obfuscate-mobile-number.pipe';

@Component({
  selector: 'aura-contact-infos-phone-display',
  templateUrl: './contact-infos-phone-display.component.html',
  imports: [ObfuscateMobileNumberPipe],
})
export class AuraContactInfosPhoneComponent {
  currentMobileNumber = input<MobileNumberDto | null>(null);
}
